import BaseScene from "../scenes/BaseScene";

export enum ButtonStyle {
    NORMAL = "normal"
}

/**
 * simple text button with hover / down styling
 *
 * @export
 * @class ImageButton
 * @extends {Phaser.GameObjects.Container}
 */
export default class ImageButton extends Phaser.GameObjects.Container {

    /**
     * if input events are enabled.
     *
     * @type {boolean}
     * @memberof ImageButton
     */
    public enabled: boolean = true;
    private clickSound: Phaser.Sound.BaseSound;

    /**
     * contains style properties of the button
     *
     * @private
     * @type {*}
     * @memberof ImageButton
     */
    private _style: any;

    /**
     * internal callback pointer
     *
     * @private
     * @memberof ImageButton
     */
    private _callback: () => void;

    /**
     *the background game object (currently image)
     *
     * @private
     * @type {Phaser.GameObjects.Image}
     * @memberof ImageButton
     */
    private _background: Phaser.GameObjects.Image;

    /**
     * the label game object (Phaser Text)
     *
     * @private
     * @type {Phaser.GameObjects.Text}
     * @memberof ImageButton
     */
    private _label: Phaser.GameObjects.Text;
    public _markedComplete: boolean;

    /**
     *Creates an instance of ImageButton.
     * @param {BaseScene} scene the scene to generate texture and target for it to be added.
     * @param {number} x postion in world
     * @param {number} y position in world
     * @param {string} label of text on button
     * @param {() => void} callback function to call on click
     * @param {ButtonStyle} [style=ButtonStyle.NORMAL] a stlye that we wish to associate
     * @memberof ImageButton
     */
    constructor(scene: BaseScene, x: number, y: number, label: string, callback: () => void, imageName: string, hoverCallback?: () => void) {

        // super to creat the container at the specified co-ordinates.
        super(scene, x, y);

        // !important - as well are using the new keyword (and not using the scene
        // factory methods, `scene.add` ) we need to add it to the scene manually
        scene.add.existing(this);

        //sfx
        this.clickSound = scene.sound.add("boop");

        // back background;
        // preferable to have a 4 frame spritesheet if all states required (2 frame if not)
        // 0: Normal / 1: hover / 2:locked OR disabled / 3:completed
        this._background = scene.add.image(0, 0, imageName);

        // make label
        this._label = scene.add.text(0, 0, label, scene.sponge.data.model.fonts.button);
        this._label.setOrigin(0.5).setFontStyle('900');

        this._markedComplete = false;

        // add to container
        this.add([this._background, this._label]);

        // set up events
        this._callback = callback;

        // as we are working with an grpahics object, we need to set it interaction with some geomerty to detect hit area.
        this._background.setInteractive({useHandCursor: true});

        // on hover entry - we are using "fat arrow" functions "()=> {...", this essentially means
        // we dont need to worry about context, as this allways relates to the current class.
        this._background.on("pointerover", () => {
            if (!this.enabled) return;
            if(!this._markedComplete){
                this._background.setFrame(1);
            }
            if(hoverCallback){
                hoverCallback();
            }
        });

        // on hover exit
        this._background.on("pointerout", () => {
            if (!this.enabled) return;
            if(!this._markedComplete){
                this._background.setFrame(0);
            }
        });

        // on up
        this._background.on("pointerup", () => {
            if (!this.enabled) return;
            if(!this._markedComplete){
                this._background.setFrame(1);
            }

            
            this.clickSound.play();
            

            this._callback();
            
            
        });

    }

    /**
     * set label test
     *
     * @memberof ImageButton
     */
    set label(newLabel: string) {
        this._label.text = newLabel;
    }

    /**
     * get label text
     *
     * @type {string}
     * @memberof ImageButton
     */
    get label(): string {
        return this._label.text;
    }

    /**
     * sets the backgorund colour of the button
     *
     * @memberof ImageButton
     */
    set colour(color: number) {
        this._background.tint = color;
    }

    set frame(fr: number) {
        this._background.setFrame(fr);
    }

    setCompleted (){
        
        this._markedComplete = true;
        this._background.setFrame(3);
    }

    setLocked (){
        this.enabled = false;
        this._background.setFrame(2);
        
    }

    setUnlocked (){
        this.enabled = true;
        this._background.setFrame(0);
        
    }
}